import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Modal,
  Form,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { useTable, useGlobalFilter, usePagination } from "react-table";
import Pagination from "components/Common/Pagination";
import { fetchNodeData, FetchNodeDeleteData } from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";
import editEventImg from "../../../assets/images/Digital Marketing/editEventImg.jpg";
import "../../../assets/css/Settings/Setting.css";
import Loader from "pages/Separate/Loader";
import axios from "axios";
import configure from "configure";
import { BiddingDocumentColumns } from "utils/columns/Marketing/TenderCols";

function TableContainer({ columns, data, fetchData, tog_center }) {
  const [modal_center, setmodal_center] = useState(false);
  const [fixedContent, setFixedContent] = useState(false);
  const [biddingId, setBiddingId] = useState(null);
  const [documentName, setDocumentName] = useState("");
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const toggleLoading = (status) => {
    setLoading(status);
  };

  function tog_center_add() {
    setmodal_center(!modal_center);
    removeBodyCss();
    setBiddingId(null);
    setDocumentName("");
    setDocument(null);
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding");
    document.body.classList.remove("no_padding");
  }

  const addNewDocument = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("name", documentName);
    formData.append("file", document);
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/biddingDocuments`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        setLoading(false);
        Swal.fire({
          icon: "success",
          text: "Document Added Successfully",
        }).then(() => {
          setmodal_center(false);
          fetchData();
        });
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleScroll = () => {
        setFixedContent(window.scrollY > 165);
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;

  return (
    <div>
      {loading && <Loader />}
      <div
        className={`flex-column fixed-buttons ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <button
          onClick={tog_center_add}
          className="btn btn-purple border-radius fix-btn"
        >
          <i className="fas fa-plus me-2 icon-size"></i>
          <span>Document</span>
        </button>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red border-radius fix-btn"
        >
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[10, 20, 30, 40, 50].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder="Search..."
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <button
              onClick={tog_center_add}
              className="border-radius btn btn-purple"
            >
              <i className="fas fa-plus me-2 icon-size"></i>Bidding Document
            </button>
            <button
              onClick={() => navigate(-1)}
              className="border-radius btn ms-md-2 btn-red"
            >
              <i className="dripicons-cross me-2 icon-center"></i>CANCEL
            </button>
          </div>
        </Col>
      </Row>
      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead className={`${fixedContent ? "fixed-setting-header" : ""}`}>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`col-md-${index === 1 || index === 2 ? "4" : "2"}`}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                  {column.isInfoIcon ? (
                    <i
                      title="info"
                      className="bx bx-info-circle ms-1 info-icon"
                    ></i>
                  ) : null}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => (
                  <td
                    className={`col-md-${
                      index === 1 || index === 2 ? "4" : "2"
                    }`}
                    key={index}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </Table>
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
      <Modal isOpen={modal_center} toggle={tog_center_add} size="lg" centered>
        <div className="modal-header py-3 px-4 border-bottom-0">
          <h5 className="modal-title mt-0">Add Bidding Document</h5>
          <button
            type="button"
            onClick={() => {
              setmodal_center(false);
              setDocument(null);
            }}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">×</span>
          </button>
        </div>
        <div className="modal-body p-4">
          <Form onSubmit={addNewDocument}>
            <Row>
              <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
                <div className="text-center">
                  <img
                    src={editEventImg}
                    alt="Bidding Document"
                    style={{ width: "90%" }}
                  />
                </div>
              </div>
              <div className="col-7 d-flex flex-column justify-content-center align-items-start">
                <div className="mb-3 col-12">
                  <label className="form-label">Name</label>
                  <Input
                    type="text"
                    value={documentName}
                    onChange={(e) => setDocumentName(e.target.value)}
                    placeholder="Enter Document Name"
                    required
                  />
                </div>
                <div className="mb-3 col-12">
                  <label className="form-label">Attachment</label>
                  <Input
                    type="file"
                    className="form-control border-radius"
                    onChange={(e) => setDocument(e.target.files[0])}
                  />
                </div>
              </div>
            </Row>
            <Row>
              <Col className="col-12 text-end">
                <button type="submit" className="btn btn-purple border-radius">
                  <i className="fas fa-save me-1"></i> Submit
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </div>
  );
}

const BiddingDocument = () => {
  const [modal_edit, setmodal_edit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState(null);
  const [biddingId, setBiddingId] = useState(null);
  const [documentName, setDocumentName] = useState("");
  const [document, setDocument] = useState(null);

  const id = localStorage.getItem("auth_id");

  const toggleLoading = (status) => {
    setLoading(status);
  };

  const fetchData = async () => {
    toggleLoading(true);
    const response = await fetchNodeData(
      toggleLoading,
      `biddingDocuments`,
      secureLocalStorage.getItem("auth_token")
    );
    if (response?.data) {
      setData(response.data);
    }
    toggleLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (e, id) => {
    e.preventDefault();
    const response = await FetchNodeDeleteData(
      toggleLoading,
      `biddingDocuments`,
      id
    );
    if (response.data) {
      fetchData();
      Swal.fire({ icon: "success", text: "Document Deleted Successfully" });
    } else {
      Swal.fire({
        icon: "error",
        text: response.data?.message || "Failed to delete document",
      });
    }
  };

  function tog_edit(editItem = null) {
    setmodal_edit(!modal_edit);
    if (editItem) {
      setEditData(editItem);
      setBiddingId(editItem.bidding_id);
      setDocumentName(editItem.documentName);
      setDocument(null);
    } else {
      setEditData(null);
      setBiddingId(null);
      setDocumentName("");
      setDocument(null);
    }
  }

  const updateDocument = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("name", documentName);
    if (document) formData.append("file", document);
    try {
      const response = await axios({
        method: "put",
        url: `${configure.nodeApi}/biddingDocuments/${editData.id}`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        setLoading(false);
        Swal.fire({
          icon: "success",
          text: "Document Updated Successfully",
        }).then(() => {
          setmodal_edit(false);
          fetchData();
        });
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const columns = useMemo(
    () => BiddingDocumentColumns(tog_edit, handleDelete),
    []
  );
  return (
    <div>
      {loading && <Loader />}
      <Row className="ms-0 pe-0">
        <Col lg={12} className="p-0">
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={data || []}
                fetchData={fetchData}
                tog_center={tog_edit}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal isOpen={modal_edit} toggle={() => tog_edit()} size="lg" centered>
        <div className="modal-header py-3 px-4 border-bottom-0">
          <h5 className="modal-title mt-0">Edit Bidding Document</h5>
          <button
            type="button"
            onClick={() => {
              setmodal_edit(false);
              setDocument(null);
            }}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">×</span>
          </button>
        </div>
        <div className="modal-body p-4">
          <Form onSubmit={updateDocument}>
            <Row>
              <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
                <div className="text-center">
                  <img
                    src={editEventImg}
                    alt="Bidding Document"
                    style={{ width: "90%" }}
                  />
                </div>
              </div>
              <div className="col-7 d-flex flex-column justify-content-center align-items-start">
                <div className="mb-3 col-12">
                  <label className="form-label">Name</label>
                  <Input
                    type="text"
                    value={documentName}
                    onChange={(e) => setDocumentName(e.target.value)}
                    placeholder="Enter Document Name"
                    required
                  />
                </div>
                <div className="mb-3 col-12">
                  <label className="form-label">Attachment</label>
                  <Input
                    type="file"
                    className="form-control border-radius"
                    onChange={(e) => setDocument(e.target.files[0])}
                  />
                  {editData?.document && (
                    <small className="text-muted">
                      Current file:{" "}
                      <a
                        href={`/${editData.document}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Document
                      </a>
                    </small>
                  )}
                </div>
              </div>
            </Row>
            <Row>
              <Col className="col-12 text-end">
                <button type="submit" className="btn btn-purple border-radius">
                  <i className="fas fa-save me-1"></i> Update
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </div>
  );
};

export default BiddingDocument;
